import NumberFormat from 'react-number-format';
import React from 'react';

const NumberFormatCustom = ({ inputRef, onChange, ...other }) => {
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value
                    }
                });
            }}
            // thousandSeparator={other.thousandSeparator}
            // prefix={other.prefix}
            // decimalScale={other.decimalScale}
        />
    );
};

export default NumberFormatCustom;
